module.exports = __webpack_public_path__ + "static/media/button-builder-1.6c5aedc5.png";